export const MAX_GPX_BYTES = 10 * 1024 * 1024;

export function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsText(file);
  });
}

export function validateGpxFile(file) {
  if (!file || !file.name.toLowerCase().endsWith(".gpx")) {
    throw new Error("Please upload a .gpx file.");
  }

  if (file.size > MAX_GPX_BYTES) {
    throw new Error("The GPX file is too large.");
  }
}

export function haversine(a, b) {
  const earthRadiusKm = 6371;
  const dLat = toRadians(b.latitude - a.latitude);
  const dLon = toRadians(b.longitude - a.longitude);
  const lat1 = toRadians(a.latitude);
  const lat2 = toRadians(b.latitude);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;

  return 2 * earthRadiusKm * Math.asin(Math.sqrt(h));
}

export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function formatDistance(value) {
  return `${formatDistanceValue(value)} km`;
}

export function formatDistanceValue(value) {
  if (!Number.isFinite(value)) {
    return "0";
  }

  const rounded = Math.round(value * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
}

export function baseFileName(fileName, fallback = "track") {
  const raw = String(fileName || fallback).split(/[\\/]/).pop() || fallback;
  return raw.replace(/\.gpx$/i, "").replace(/\.kml$/i, "").replace(/[^a-z0-9_-]+/gi, "-").replace(/^-+|-+$/g, "") || fallback;
}

export function escapeXml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

export function createDownloadUrl(text, type) {
  return URL.createObjectURL(new Blob([text], { type }));
}

function toRadians(value) {
  return value * Math.PI / 180;
}
